<template>
  <ModalOperator type="error" :ghost="false"  size="default" text="绑定双创账号" title="绑定双创账号" width="30%" >
    <zpa-form ref="Form" >
      <zpa-form-group>

        <zpa-text-input
          label="双创账号"
          v-model="data.userName"
          required
        />
        <zpa-text-input
          label="双创密码"
          v-model="data.password"
          required
          style="margin-top: 20px"
        />
        <span style="color: red;margin-top: 20px;margin-bottom: -20px">注意：绑定成功后,将退出系统，请重新登录</span>
      </zpa-form-group>
    </zpa-form>
  </ModalOperator>
</template>
<script>
import ModalOperatorMixin from '@/components/commons/ModalOperatorMixin'
import { bindScUser, loginout } from '@/api/login'
// import {changepwdEjy} from '@/api/fwsc/bank'
// import {
//   allowPush,
// } from '@/api/xmsb/register'

export default {
  name: 'ChangePwd',

  mixins: [
    ModalOperatorMixin,
  ],
  created() {
  },
  methods: {
    initialize() {
      this.data = {
        userName: '',
        password: ''
      }
    },
    async beforeOpen() {
      // let _currentuser = await
      // getCurrentuser()
      // let _data = this.data
      // this.data = {..._currentuser.userInfo,
      //   ..._data
      // }
    },

    async beforeSubmit() {
      // let _checkpwd = await
      // checkpwd({password: this.data.oldpassword})
      // let _this = this
      // if (!_checkpwd) {
      //   _this.$Message.error('旧密码输入不正确！')
      // }
      return this.$refs['Form'].validate()
    },

    onSubmit() {
      let _this = this
      bindScUser(this.data).then((testData) => {
        _this.$Message.success('绑定成功！')
        loginout()
        _this.$store.commit('SET_AUTHORIZES', { allAuthorizes: {}, authorizes: {}})
        localStorage.setItem('authorizesInfo', {})
        // 刷新退出
        window.location.replace('https://pass.jscz.org.cn/')
      },
      function (reason, testData) {
        _this.$Message.error(reason)
      })
      //   }
      // })
    },

  },
}
</script>
